import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { TextField } from '@mui/material';
import '@babel/runtime/helpers/toConsumableArray';
import { useSafeId } from '../../hooks/useSafeId/useSafeId.hook.js';
var _excluded = ["value", "disabled", "error", "fullWidth", "helperText", "label", "placeholder", "minRows", "maxRows", "required", "margin", "variant", "onChange", "id", "InputProps", "readOnly", "autoFocus", "dataProp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TextArea = function TextArea(props) {
  var value = props.value,
      disabled = props.disabled,
      error = props.error,
      fullWidth = props.fullWidth,
      helperText = props.helperText,
      label = props.label,
      placeholder = props.placeholder,
      minRows = props.minRows,
      maxRows = props.maxRows,
      required = props.required,
      margin = props.margin,
      variant = props.variant,
      onChange = props.onChange,
      id = props.id,
      _props$InputProps = props.InputProps,
      InputProps = _props$InputProps === void 0 ? {} : _props$InputProps,
      readOnly = props.readOnly,
      autoFocus = props.autoFocus,
      dataProp = props.dataProp,
      rest = _objectWithoutProperties(props, _excluded);

  var safeId = useSafeId(id);
  return /*#__PURE__*/React.createElement(TextField, _extends({
    value: value,
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    helperText: helperText,
    label: label,
    placeholder: placeholder,
    minRows: minRows,
    maxRows: maxRows,
    required: required,
    margin: margin,
    variant: variant,
    onChange: onChange,
    id: safeId,
    InputProps: _objectSpread({
      readOnly: readOnly,
      autoFocus: autoFocus,
      inputProps: {
        'data-selector': dataProp ? dataProp : null
      }
    }, InputProps)
  }, rest, {
    multiline: true
  }));
};

TextArea.defaultProps = {
  margin: 'normal',
  fullWidth: true,
  label: '',
  minRows: 4,
  variant: 'filled',
  readOnly: false,
  autoFocus: false
};
TextArea.displayName = 'TextArea';
export { TextArea };